<template>

    <main class="page-invoice" role="main">

        <router-view />

    </main>

</template>

<script>
export default
{
    name: 'Invoice',
}
</script>



// WEBPACK FOOTER //
// Invoice.vue?b89bd42a